import type { Messages } from './en';

/** 階段 A：英語護照與第一次的教學。 */
export const zhTWGuide: Pick<Messages, 'passport' | 'tutorial'> = {
  passport: {
    title: '🛂 英語護照',
    tool: '護照',
    levels: ['新手', 'A1 探險家', 'A2 旅行家', 'B1 小講者', 'B1+ 明星', 'B2 冠軍'],
    xp: (n: number) => `${n} XP`,
    next: (n: number) => `再 ${n} XP 就升級`,
    top: '已經到最高等級了，太厲害了！',
    levelUp: (name: string) => `🎉 英語新等級：${name}！`,
    newStamp: '🛂 你的英語護照多了一個新印章！',
    stats: {
      known: '認識的單字',
      mastered: '已精通',
      spelled: '拼對的',
      shadowed: '大聲說出',
      talks: '角色扮演',
      stories: '故事',
      stamps: '印章',
    },
    talkStamps: '角色扮演印章',
    placeStamps: '地點與節慶',
    notYet: '還沒有',
    week: '最近幾天',
    legend: { words: '單字', talks: '對話', spells: '拼字' },
    day: (n: number) => `第${n}天`,
    parents: '👨‍👩‍👧 給家長看',
    parentsHint: '孩子練習過的內容。「繼續練習」裡的單字會一直出現在複習中，直到記住為止。',
    strong: '熟練的單字',
    weak: '繼續練習',
    none: '目前還沒有',
    practise: '🎤 去英語角',
    stampNames: {
      nightMarket: '夜市',
      lantern: '元宵節',
      dragonBoat: '端午節',
      moon: '中秋節',
      newYear: '農曆新年',
      taipei101: '台北101',
      mrt: '台北捷運',
      museum: '故宮博物院',
      taroko: '太魯閣',
      beach: '七星潭',
      jiufen: '九份老街',
      xiangshan: "象山",
      ximen: "西門町",
      longshan: "龍山寺",
      cks: "中正紀念堂",
      beitou: "北投溫泉",
      dongdamen: "東大門夜市",
      jian: "吉安",
    },
  },
  tutorial: {
    skip: '跳過',
    next: '下一步 ›',
    back: '‹ 上一步',
    done: '▶ 開始玩吧！',
    menu: '❓ 怎麼玩',
    steps: [
      { title: '歡迎！', text: '這是你在台灣的小鎮。過你的校園生活、幫助大家，順便學英文！' },
      { title: '到處走走', text: '用方向鍵，或直接點地圖上的任何地方就能走過去。' },
      { title: '說話和使用東西', text: '靠近人或東西的時候，這個按鈕會亮起來。點它就能聊天、買東西、玩遊戲……' },
      { title: '跳！', text: '跳過樹籬、圍欄和草叢。有些秘密要跳起來才拿得到喔。' },
      { title: '接下來做什麼', text: '你的下一個目標都會寫在這裡，地圖上的金色箭頭會幫你指路。' },
      { title: '你的日誌', text: '今天的目標、故事章節和所有任務都在這裡。頭上有 ❗ 的人有事要找你。' },
      { title: '你的手機', text: '聊天、通話、PixelBook、廣播——還有所有工具：練英文、電玩、尋寶、英語護照。小心詐騙！' },
      { title: '選單', text: '在這裡可以暫停、換語言、關掉聲音或存檔。玩得開心！' },
    ],
  },
};
